/**
 * @desc is where we kick off the app!
 */

c.el.doc.ready(
	c.fn.execute_ready
);


